import { type FC } from 'react';
import { useTranslation } from 'react-i18next';
import { formatter, Task } from '@repo/shared';

import type { AggregateClusterResponse } from '@/api/generated.schemas';
import { CardContent } from '@/components/ui/card';

type ClusterMetric = AggregateClusterResponse[number];

interface ClusterMetricsDetailsProps {
  cluster: ClusterMetric;
}

const ClusterMetricsDetails: FC<ClusterMetricsDetailsProps> = ({ cluster }) => {
  const { t } = useTranslation();

  if (!cluster.metrics?.task) {
    return null;
  }

  switch (cluster.metrics.task) {
    case Task.TEXT_TRANSLATION:
      return (
        <CardContent className='grid grid-cols-[1fr_0.1fr] gap-2'>
          <span>{t('metrics.bleu')}</span>
          <span>{formatter.metrics.bleu(cluster.metrics.bleu)}</span>
          <span>{t('metrics.comet')}</span>
          <span>{formatter.metrics.comet(cluster.metrics.comet)}</span>
        </CardContent>
      );
    case Task.GENERATE_AUDIO:
      return (
        <CardContent className='grid grid-cols-[1fr_0.1fr] gap-2'>
          <span>{t('metrics.wordsPerMinute')}</span>
          <span>
            {formatter.metrics.wordsPerMinute(cluster.metrics.wordsPerMinute)}
          </span>
          <span>{t('metrics.wordErrorRate')}</span>
          <span>
            {formatter.metrics.wordErrorRate(cluster.metrics.wordErrorRate)}
          </span>
        </CardContent>
      );
    case Task.EXTRACT_STRUCTURE:
      return (
        <CardContent className='grid grid-cols-[1fr_0.1fr] gap-2'>
          <span>{t('metrics.cer')}</span>
          <span>{formatter.metrics.cer(cluster.metrics.cer)}</span>
          <span>{t('metrics.wer')}</span>
          <span>{formatter.metrics.wer(cluster.metrics.wer)}</span>
          <span>{t('metrics.structuralDistance')}</span>
          <span>
            {formatter.metrics.structuralDistance(
              cluster.metrics.structuralDistance
            )}
          </span>
        </CardContent>
      );
    default:
      return null;
  }
};

export default ClusterMetricsDetails;
